"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Modal;
var React = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _Icon = _interopRequireWildcard(require("./Icon"));
var _Button = require("./Button");
var _utils = require("./utils");
var _PageScroll = _interopRequireDefault(require("./PageScroll"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
_reactModal.default.setAppElement((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && document.getElementById('__next') ? '#__next' : '#root');
function openEffect(o) {
  if (o === 'fade') return '';
  if (o === 'right') return '-open-from-right';
  return '-open-from-top';
}
function Modal(props) {
  var _useState = (0, React.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    minimize = _useState2[0],
    setMinimize = _useState2[1];
  var _useState3 = (0, React.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    bodyHeight = _useState4[0],
    setBodyHeight = _useState4[1];
  var modelRef = (0, React.useRef)();
  var bodyRef = (0, React.useRef)();
  var contentRef = (0, React.useRef)();
  var dragRef = (0, React.useRef)();

  // ----- EVENT

  var onDragStart = function onDragStart(e) {
    if (props.draggable) {
      dragRef.current = true;
      if (modelRef.current) {
        var re = modelRef.current.getBoundingClientRect();
        modelRef.current.style.transform = 'none';
        modelRef.current.style.position = 'fixed';
        modelRef.current.style.left = re.x + 'px';
        modelRef.current.style.top = re.y + 'px';
        modelRef.current.dataset.pos = [re.x, re.y, e.clientX, e.clientY].join(',');
      }
    }
  };
  var onDrag = function onDrag(e) {
    if (props.draggable) {
      if (dragRef.current && modelRef.current) {
        var pos = modelRef.current.dataset.pos.split(',').map(function (d) {
          return parseInt(d);
        });
        var x = pos[0] + (e.clientX - pos[2]);
        var y = pos[1] + (e.clientY - pos[3]);
        modelRef.current.style.left = x + 'px';
        modelRef.current.style.top = y + 'px';
      }
    }
  };
  var onDragEnd = function onDragEnd() {
    dragRef.current = false;
  };
  var onScroll = function onScroll(e) {
    if (e.target) {
      if (props.onScroll) props.onScroll(e);
    }
  };

  // ----- MEMO

  (0, React.useEffect)(function () {
    if (props.draggable) {
      document.addEventListener('mouseup', onDragEnd);
      document.addEventListener('mousemove', onDrag);
    }
    return function () {
      if (props.draggable) {
        document.removeEventListener('mouseup', onDragEnd);
        document.removeEventListener('mousemove', onDrag);
      }
    };
  }, []);
  (0, React.useEffect)(function () {
    var timer;
    if (props.open) {
      setTimeout(function () {
        setBodyHeight(contentRef.current.contentEl.offsetHeight);
      }, 10);
      timer = setInterval(function () {
        setBodyHeight(function (c) {
          if (c !== contentRef.current.contentEl.offsetHeight) return contentRef.current.contentEl.offsetHeight;
          return c;
        });
      }, 250);
    } else {
      if (timer) clearInterval(timer);
    }
    return function () {
      if (timer) clearInterval(timer);
    };
  }, [props.open, props.children, bodyRef.current, contentRef.current]);

  // ----- RENDER

  var size = ['xs', 'sm', 'md', 'lg', 'xl', 'full'].find(function (s) {
    return props.hasOwnProperty(s);
  });
  var modalProps = {
    isOpen: props.open || props.static || false,
    portalClassName: 'un-modal-portal',
    bodyOpenClassName: (0, _utils.clsNames)('un-modal-open', props.noBackdrop && '-disabled', props.static && !props.open && '-static-hide'),
    overlayClassName: (0, _utils.clsNames)('un-modal-overlay', props.noBackdrop && '-disabled', props.static && !props.open && '-static-hide', openEffect(props.openEffect)),
    className: (0, _utils.clsNames)('un-modal', size && 'un-modal-' + size, props.fullHeight && '-full-height', minimize && '-minimize', props.className, props.static && !props.open && '-static-hide'),
    shouldCloseOnOverlayClick: !props.noCloseBackdrop,
    onRequestClose: function onRequestClose() {
      if (!props.noBackdrop && !props.noCloseBackdrop && !minimize) props.onClose();
    },
    onAfterOpen: function onAfterOpen() {
      if ((props.draggable || props.startPosition) && modelRef.current) {
        var x = function (el, sc, d) {
          if (d) {
            if (d.left !== undefined) return d.left;
            if (d.right !== undefined) return sc - el - d.right;
          }
          return (sc - el) / 2;
        }(modelRef.current.offsetWidth, window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth, props.startPosition);
        var y = function (el, sc, d) {
          if (d) {
            if (d.top !== undefined) return d.top;
            if (d.bottom !== undefined) return sc - el - d.bottom;
          }
          return 20;
        }(modelRef.current.offsetHeight, window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight, props.startPosition);
        modelRef.current.style.left = x + 'px';
        modelRef.current.style.top = y + 'px';
        //  && typeof props.draggable === 'object'
      }

      if (props.onOpenEnd) props.onOpenEnd();
    }
  };
  var onClose = function onClose() {
    if (props.onClose) props.onClose();
  };
  if (props.onCloseEnd) modalProps.onAfterClose = props.onCloseEnd;
  var footerSave = function footerSave() {
    if (typeof props.footerSave === 'function') return /*#__PURE__*/React.createElement(_Button.ButtonSave, {
      onSave: props.footerSave
    });
    if (Array.isArray(props.footerSave) && props.footerSave.length === 2) return /*#__PURE__*/React.createElement(_Button.ButtonSave, {
      onSave: props.footerSave[0],
      children: props.footerSave[1].labelButton
    });
  };
  return /*#__PURE__*/React.createElement(_reactModal.default, _extends({
    contentRef: function contentRef(node) {
      return modelRef.current = node;
    }
  }, modalProps), /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-modal-header', props.draggable && '-draggable', props.classHead),
    onMouseDown: onDragStart
  }, !!props.icon && /*#__PURE__*/React.createElement(_Icon.default, {
    button: !!props.onIconClick,
    name: props.icon,
    className: "un-modal-icon",
    onClick: props.onIconClick
  }), !!props.title && /*#__PURE__*/React.createElement("div", {
    className: "un-modal-title"
  }, props.title), props.menu && /*#__PURE__*/React.createElement("div", {
    className: "un-modal-header-menu"
  }, props.menu), /*#__PURE__*/React.createElement("div", {
    className: "un-modal-header-ext"
  }, props.header), props.minimize && /*#__PURE__*/React.createElement(_Icon.default, {
    button: true,
    name: minimize ? 'window-maximize' : 'window-minimize',
    className: "un-modal-minimize",
    onClick: function onClick() {
      return setMinimize(function (prev) {
        return !prev;
      });
    }
  }), /*#__PURE__*/React.createElement(_Icon.default, {
    button: true,
    name: 'times',
    className: "un-modal-close",
    onClick: onClose
  })), props.neck && /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-modal-neck', props.classNeck)
  }, props.neck), !minimize && /*#__PURE__*/React.createElement("div", {
    ref: bodyRef,
    className: (0, _utils.clsNames)('un-modal-body', props.classBody)
  }, /*#__PURE__*/React.createElement(_PageScroll.default, {
    ref: contentRef,
    height: bodyHeight,
    classContainer: 'un-modal-body-scroll'
  }, props.children)), !minimize && (!!props.footer || !!props.footerSave || !!props.footerDrop) && /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-modal-footer', props.classFoot)
  }, !!props.footerDrop && /*#__PURE__*/React.createElement(_Icon.IconDelete, {
    className: "ml-4",
    onClick: props.footerDrop
  }), !!props.footer && props.footer, !!props.footerSave && footerSave()));
}
//  onScroll={onScroll}